export default __webpack_public_path__ + "static/media/E2.cd5251c4.jpg";